import { Skeleton, Table } from '@mantine/core';

interface OrdersTableSkeletonProps {
    columns: number;
}

const skeletonRows = Array.from({ length: 5 }, (_, index) => index);

export const OrdersTableSkeleton = ({ columns }: OrdersTableSkeletonProps) => {
    return skeletonRows.map((row) => (
        <Table.Tr key={row}>
            {Array.from({ length: columns }, (_, column) => (
                <Table.Td key={column}>
                    <Skeleton h={24} />
                </Table.Td>
            ))}
        </Table.Tr>
    ));
};
